import React from 'react';
import { Oval } from  'react-loader-spinner';
import {
    Input,
    Button,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Navbar,
    Nav,
    NavLink,
    Row,
    Col,
    Form,
    CustomInput,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import ReactTable from "react-table";
import { connect } from "react-redux";
import NavBar from '../NavBar/navBar'
import {
    fetchLocationList,
    saveNotification,
    updateNotification,
    updateRecurrentNotifications,
    deleteNotification,
    deleteMultipleNotifications,
    fetchBuilding,
    fetchFloors,
    downloadnotificationData,
    updateLocationStateFilters
} from '../../actions';
import Pagination from '../Pagination/pagination'
import { toast, ToastContainer } from 'react-toastify';
import { NavLink as RRNavLink } from 'react-router-dom';
import MultiSelect from '@khanacademy/react-multi-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faSyncAlt,faCalendar, faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import Tour from '../../Tour';
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-toastify/dist/ReactToastify.css";
import './notifications.css';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import radioButton from '../../assets/radioButton.svg'
import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg'

let errorDetails = ""
const notificationScanRef = React.createRef();

const initialState = {
    id: "",
    datetime: "",
    description: "",
    toDate: "",
    fromDate: "",
    selected: [],
    typeofNotification: "",
    typeofSamples: "",
    location: "",
    building: "",
    floor: "",
    buildingId: "",
    floorId: "",
    buildingName: "",
    floorName: "",
    isDeleteModalOpen: false,
    isRecurrentModalOpen: false,
    deleteID: "",
    deleteDate: "",
    eventID: "",
    isDisable: false,
    edit: false,
    isEditModalOpen: false,
    view: true,
    type: "direct",
    isMultiDeleteModalOpen: false,
    isDeleteAllModalOpen: false,
    checked: [],
}

let editId = ""
class Notification extends React.Component {
    constructor(props) {
        super(props)
        this.saveData = this.saveData.bind(this)
        this.resetData = this.resetData.bind(this)
        this.onChange = this.onChange.bind(this)
        this.validateData = this.validateData.bind(this)
        this.deleteNotification = this.deleteNotification.bind(this)
        this.deleteMultipleNotifications = this.deleteMultipleNotifications.bind(this)
        this.updateRecurrentData = this.updateRecurrentData.bind(this)
        this.onSelectBuilding = this.onSelectBuilding.bind(this)
        this.onSelectFloor = this.onSelectFloor.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.getRecurrentNotificationCreateData = this.getRecurrentNotificationCreateData.bind(this)
        this.state = {
            ...initialState,
            datetime: new Date(),
            minTime: this.getMinTime(new Date()),
            isLocationScan: false,
            loaderNotification: true,
        }
    }
    columns = [
        {
            Header: state => (
                <CustomInput type="checkbox" 
                className="custom-selectall-checkbox"
                id="notification-all-samples"
                checked={this.props.downloadnotification.length===this.state.checked.length}
                intermediate={this.state.checked.length!==0 && this.props.downloadnotification.length>this.state.checked.length}
                onClick={() => this.selectAll()}/>
                ),
            id: 'checkbox',
            accessor: str => "checkbox",
            Cell: (row) => {
                let checked = this.state.checked.includes(row.index)
                return <CustomInput type="checkbox" className={checked?"custom-table-checkbox select-checked":"custom-table-checkbox"} id={row.original.id} checked={checked} onClick={() => this.handleCheckClick(row.index)}/>
            },
            width: 50,
            filterable:false,
            headerClassName: 'checkbox-sticky-style',
            className: 'checkbox-sticky-style'
        },
        {
            Header: 'Date & Time',
            accessor: 'datetime',
            Cell: (props) => {
                let date = new Date(props.value)
                date = moment(date).format('MMM D, YYYY HH:mm')
                return <span>{date}</span>
            },
            width: 180
        },
        {
            Header: 'Message',
            accessor: 'description',
            width: 250
        },
        {
            Header: 'Type of Notification',
            accessor: 'type_of_notification',
            Cell: (row) => (
                <div title="Type of Notification">
                   {row.value === "Recurring"?<FontAwesomeIcon className="icons" id={"deleteButton" + row.original.id} icon={faSyncAlt} size="lg" title="Recurring"
                        onClick={() => {
                            let data = this.props.downloadnotification;
                            this.toggleRecurrentModal(data[row.index])
                        }} data-tut="reactour__editAll"></FontAwesomeIcon>: <FontAwesomeIcon className="icons" id={"deleteButton" + row.original.id} icon={faClock} size="lg" title="One Time"
                            onClick={() => {
                            let data = this.props.downloadnotification;
                            this.toggleEditModal(data[row.index])
                        }} data-tut="reactour__one"></FontAwesomeIcon>}
                </div>
            ),
            width: 150,
            className:"type-of-notification",
        },
        {
            Header: 'Type of Sample',
            accessor: 'type_of_samples',
            width: 120,
        },
        {
            Header: 'Location ID',
            id: 'location',
            accessor: str => "location",
            Cell: (row) => {
                if (row.original.unit) {
                    return <div>{row.original.location.location_id + ', ' + row.original.unit.unit_id}</div>
                }
                else if (row.original.location){
                    return <div>{row.original.location.location_id}</div>
                	}
                else
                return <></>
            
        },
            width: 180,
        },
    ]

    handleButtonClick = (e, row) => {
        let date = new Date(row.original.datetime)
        date = moment(date).format('MMMM D, YYYY HH:mm')
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteDate: date,
            deleteID: row.original.id
        }));
    }

    componentDidMount() {
        this.props.fetchBuilding()
        let persist_root = localStorage.getItem('persist:root')
        var root = JSON.parse(persist_root);
        var notification_data = JSON.parse(root.notification_data)
        this.props.downloadnotificationData().then(
            response => {
                this.setState({ loaderNotification: false })
            }
        )
        if(notification_data.downloadnotificationData===undefined || notification_data.downloadnotificationData.length===0 ){
            this.setState({ loaderNotification: true })
        }
        else{
            this.setState({ loaderNotification: false })
        }
    }

    onSelectBuilding = (event) => {
        const { value, selectedOptions } = event.target
        this.setState({
            ...this.state,
            building: value,
            buildingId: selectedOptions[0].id,
            buildingName: selectedOptions[0].innerText,
            floor: "",
        }, async () => {
            await this.props.fetchFloors(this.state.buildingId)
        })
    }

    onSelectFloor = (event) => {
        const { value, selectedOptions } = event.target
        this.setState({
            ...this.state,
            floor: value,
            floorId: selectedOptions[0].id,
            floorName: selectedOptions[0].innerText,
        }, () => {
            this.props.fetchLocationList({
                floor__id: this.state.floorId,
                floor__building_id: this.state.buildingId
            })
        })
    }

    deleteNotification = () => {
        this.props.deleteNotification(this.state.deleteID).then(response => {
            if (response.status === 204) {
                appInsights.trackEvent({name:'Notification Deleted', properties: {id: this.state.deleteID}});
                appInsights.trackTrace({message: 'Notification with ID '+ this.state.deleteID+' is deleted', severityLevel: SeverityLevel.Information});
                toast.success("Notification is marked as done!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.props.downloadnotificationData()
            }
            else {
                appInsights.trackTrace({message: 'Notification couldn\'t marked as done!', properties: {id: this.state.deleteID}, severityLevel: SeverityLevel.Error});
                toast.error("Notification couldn't marked as done!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        })
        this.resetData()
    }

    deleteMultipleNotifications = (e) => {
        this.props.deleteMultipleNotifications({event_id: this.state.eventID}).then(response => {
            if (response.status === 204) {
                appInsights.trackEvent({name:'Notification Deleted', properties: {eventID: this.state.eventID}});
                appInsights.trackTrace({message: 'Notifications with Event ID '+ this.state.eventID+' is deleted', severityLevel: SeverityLevel.Information});
                toast.success("All Notifications of the Recurring event are deleted!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.props.downloadnotificationData()
            }
            else {
                appInsights.trackTrace({message: "Notifications couldn't be deleted!", properties: {eventID: this.state.eventID}, severityLevel: SeverityLevel.Error});
                toast.error("Notifications couldn't be deleted!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        })
        this.resetData()
    }

    deleteSelectedNotifications = () =>{
        let selectedIds = this.state.checked.map((data) => this.props.downloadnotification[data].id)
        let ids =  selectedIds.join(',')
        this.props.deleteMultipleNotifications({ids: ids}).then(response =>{
            if (response.status === 204){
                toast.success("All Selected Notifications marked as done!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.props.downloadnotificationData()
            }
            else {
                appInsights.trackTrace({message: "Notifications couldn't be deleted!", properties: {eventID: this.state.eventID}, severityLevel: SeverityLevel.Error});
                toast.error("Notifications couldn't be deleted!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        })
        this.resetData()
    }

    toggleDeleteModal = () => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteLocationId: ""
        }));
    }

    toggleMultiDeleteModal = () => {
        this.setState(prevState => ({
            isMultiDeleteModalOpen: !prevState.isMultiDeleteModalOpen,
        }));
    }

    toggleDeleteAllModel = () => {
        this.setState(prevState => ({
            isDeleteAllModalOpen: !prevState.isDeleteAllModalOpen,
            isRecurrentModalOpen: !prevState.isRecurrentModalOpen,
        }));
    }

    toggleEditModal = (data) => {
        this.setState(prevState => ({
            isEditModalOpen: !prevState.isEditModalOpen,
        }))
        return data.id ? this.modifySample(data) : null
    }

    toggleRecurrentModal = (data) => {
        this.setState(prevState => ({
            isRecurrentModalOpen: !prevState.isRecurrentModalOpen,
        }))
        return data.id ? this.modifyRecurrentSample(data) : null
    }

    onChange = date => {
        return this.setState({ datetime: date, minTime: this.getMinTime(date) })
    };

    onChangeDate = date => {
        return this.setState({ editdate_time: date, editMinTime: this.getMinTime(date) })
    }
    onChangeToDate = date => {
        return this.setState({ toDate: date})
    }

    handleChange(event) {
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        })
    };

    getRecurrentNotificationCreateData = notificationData => {
        let data = []
        let start = moment(this.state.datetime).subtract(moment(this.state.datetime).day(), 'days')
        let end = moment(this.state.toDate).add(1, 'days')
    
        for(let i=0; i<=end.diff(start,'days'); i+=7){
            this.state.selected.forEach((j) => {
                let datetime = moment(start).add(i+j, 'days')
                if(datetime>=this.state.datetime && datetime<=end)
                    data.push({
                        datetime: new Date(datetime).toISOString(), ...notificationData
                    })
            })
        }
        return data
    }

    saveData = () => {
        if (this.validateData(this.state)) {
            let split_data = this.state.location.split(',')
            let location = split_data[0]
            let unit = ""
            if (split_data.length === 2) {
                unit = split_data[1]
            }
            if (this.state.edit) {
                if (editId === this.state.id) {
                    editId = ""
                    this.setState({
                        isDisable: false,
                        edit: false
                    })
                    var data = {
                        id: this.state.id,
                        user: this.state.user,
                        email: this.state.email,
                        datetime: this.state.editdate_time,
                        description: this.state.editMessage,
                        type_of_samples: this.state.edittypeofSamples,
                        type_of_notification: "One Time",
                        location: location,
                        unit: unit,
                        event_id: this.state.edit_typeofNotification === 'Recurring'?'OT'+this.state.eventID.slice(2):this.state.eventID
                    }
                    this.props.updateNotification({
                        data
                    }).then(response => {
                        if (response.status === 200) {
                            appInsights.trackEvent({name:'Notification Updated', properties: {id: response.data.id, name: response.data.description}});
                            appInsights.trackTrace({message:'Notification Updated', properties: {id: response.data.id, name: response.data.description}, severityLevel: SeverityLevel.Information})
                            toast.success("Notification is Updated Successfully!", {
                                position: toast.POSITION.BOTTOM_RIGHT
                            });
                            this.props.downloadnotificationData()
                        }
                        else {
                            appInsights.trackTrace({message:"Notification couldn't be updated!", properties: {id: this.state.id, name: this.state.editMessage}, severityLevel: SeverityLevel.Error})
                            toast.error("Notification couldn't be updated!", {
                                position: toast.POSITION.BOTTOM_RIGHT
                            });
                        }
                    })
                        .catch((error) => {
                            appInsights.trackTrace({message:"Notification couldn't be updated!", properties: {id: this.state.id, name: this.state.editMessage, error: error}, severityLevel: SeverityLevel.Error})
                            toast.error("Notification couldn't be updated!", {
                                position: toast.POSITION.BOTTOM_RIGHT
                            })
                        })
                    this.resetData()
                }
                else {
                    appInsights.trackTrace({message: "ID can't be updated while editing!", severityLevel: SeverityLevel.Verbose})
                    toast.error("ID can't be updated while editing!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }
            else {
                let data
                let notificationData = {
                            description: this.state.description, 
                            type_of_notification: this.state.typeofNotification,
                            location: location,
                            unit: unit,
                            type_of_samples: this.state.typeofSamples
                        }
                if (this.state.typeofNotification === "Recurring")
                    data = this.getRecurrentNotificationCreateData(notificationData)
                else{
                    notificationData['datetime'] = new Date(this.state.datetime).toISOString()
                    data = [notificationData]
                }
                this.props.saveNotification(data).then(response => {
                    if (response.status === 201) {
                        appInsights.trackEvent({name:'Notification Added', properties: {id: response.data[0].id, name: response.data[0].description}});
                        appInsights.trackTrace({message:"Notification Added", properties: {id: response.data[0].id, name: response.data[0].description}, severityLevel: SeverityLevel.Information})
                        toast.success("Notification is added successfully to the list", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        this.props.downloadnotificationData()
                    }
                    else {
                        appInsights.trackTrace({message:"Notification couldn't be added!", properties: {name: this.state.description}, severityLevel: SeverityLevel.Error})
                        toast.error("Notification couldn't be added!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                })
                    .catch((error) => {
                        appInsights.trackTrace({message:"Notification couldn't be added!", properties: {name: this.state.description, error: error}, severityLevel: SeverityLevel.Error})
                        toast.error("Notification couldn't be added !", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        })
                    })
                this.setState({
                    datetime: new Date(),
                    description: "",
                    typeofSamples: "",
                    todate: "",
                    isDeleteModalOpen: false,
                    isRecurrentModalOpen: false,
                    deleteID: "",
                    deleteDate: "",
                    eventID: "",
                    location: "",
                    selected: ""
                })
            }
        }
        else {
            this.ErrorDetails()
        }
    }

    ErrorDetails = () => {
        appInsights.trackTrace({message: errorDetails, severityLevel: SeverityLevel.Verbose})
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    updateRecurrentData = () => {
        if (this.state.edit) {
                editId = ""
            let split_data = this.state.location.split(',')
            let location = split_data[0]
            let unit = null
            if (split_data.length === 2) {
                unit = split_data[1]
            }
                this.setState({
                    isDisable: false,
                    edit: false
                })
                let date = this.state.editdate_time
                let hours = date.getHours()
                let minutes = date.getMinutes()

                var data = this.props.downloadnotification.filter(val => val.event_id === this.state.eventID)
                data.forEach((item, index, list) =>{
                    let date = new Date(item.datetime)
                    date.setHours(hours)
                    date.setMinutes(minutes)
                    list[index].datetime = date.toISOString()
                    list[index].description = this.state.editMessage
                    list[index].location = location
                    list[index].unit = unit
                    list[index].type_of_samples = this.state.edittypeofSamples
                })
                this.props.updateRecurrentNotifications(data).then(response => {
                    if (response.status === 200) {
                        appInsights.trackEvent({name:'Notification Updated', properties: {eventID: response.data[0].event_id, name: response.data[0].description}});
                        appInsights.trackTrace({message:'Notification Updated', properties: {eventID: response.data[0].event_id, name: response.data[0].description}, severityLevel: SeverityLevel.Information})
                        toast.success("Notifications are Updated Successfully!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        this.props.downloadnotificationData()
                    }
                    else {
                        appInsights.trackTrace({message:'Notifications couldn\'t be updated!', properties: {eventID: this.state.eventID, name: this.state.editMessage}, severityLevel: SeverityLevel.Error})
                        toast.error("Notifications couldn't be updated!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                })
                    .catch((error) => {
                        appInsights.trackTrace({message:'Notifications couldn\'t be updated!', properties: {eventID: this.state.eventID, name: this.state.editMessage, error: error}, severityLevel: SeverityLevel.Error})
                        toast.error("Notifications couldn't be updated!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        })
                    })
                this.resetData()
            }
    }
    resetData = () => {
        this.setState({
            ...initialState,
            view: true
        }, () => {
            this.props.fetchFloors(this.state.buildingId)
            this.props.fetchLocationList()
        })
        this.props.downloadnotificationData()
    }

    cancelData = () => {
        this.setState(initialState)
    }

    validateData = (data) => {
        let isValidDate = moment(data.datetime).isValid()
        let isValidToDate = moment(data.toDate).isValid()
        let isvalidEditDate = moment(data.editdate_time).isValid()
        if (data.edit) {
            if (isvalidEditDate && data.editMessage.length > 0 ){
                return true
            }
            else if (data.editMessage.trim().length === 0){
                errorDetails = "Message is empty!"
                return false
            }
            else if (!isvalidEditDate){
                errorDetails = "Select a valid DateTime!"
                return false
            }
            else {
                errorDetails = "All *mandatory fields are required to update Notification"
                return false
            }
        }
        else {
            if(data.typeofNotification !== 'Recurring' && data.typeofNotification !== 'One Time'){
                errorDetails = "Select a valid Notification Type!"
                return false
            }
            else if (data.typeofNotification === 'Recurring' && isValidDate && isValidToDate && data.description.trim().length > 0 && data.selected.length > 0){
                return true
            }
            else if (data.typeofNotification === 'One Time' && isValidDate && data.description.length > 0 ){
                return true
            }
            else if (data.description.trim().length === 0){
                errorDetails = "Message is empty!"
                return false
            }
            else if (data.typeofNotification === 'Recurring' && data.selected.length === 0){
                errorDetails = "Select atleast One Day!"
                return false
            }
            else if (!isValidDate){
                errorDetails = "Select a valid DateTime!"
                return false
            }
            else if (data.typeofNotification === 'Recurring' && !isValidToDate){
                errorDetails = "Select a valid To Date!"
                return false
            }
            else {
                errorDetails = "All *mandatory fields are required to create Notification"
                return false
            }
        }
    }

    modifySample = (data) => {
        let date = new Date(data.datetime)
        editId = data.id
        let unit
        if (data.unit) {
            unit = data.unit.id
        }
        let building = data.location?data.location.floor.building.id:""
        let floor = data.location?data.location.floor.id:""
        let building_filter = this.props.buildingList.filter(val => val.id === building)
        let floor_filter = building_filter.length !== 0?building_filter[0].floors.filter(val => val.id === floor)[0]:""
        if(floor_filter)
            this.props.fetchFloors(floor_filter.building)

        this.props.fetchLocationList({
            floor__id: floor_filter?floor_filter.id:"",
            floor__building_id: floor_filter?floor_filter.building:""
        })
        this.setState({
            "id": data.id,
            "eventID": data.event_id,
            "user": data.user,
            "email": data.email,
            "editdate_time": date,
            "editMessage": data.description,
            "edit_typeofNotification": data.type_of_notification,
            "edittypeofSamples": data.type_of_samples,
            "building": building,
            "floor": floor,
            "location": data.unit ? data.location.location_id + ',' + unit : data.location?data.location.location_id:"",
            "isDisable": true,
            "edit": true,
            "editMinTime": this.getMinTime(date)
        })
    }

    modifyRecurrentSample = (data) =>{
        this.modifySample(data);
        let fromDate
        this.props.downloadnotification.every( obj => {
            if(data.event_id === obj.event_id){
                fromDate = obj.datetime
                return false
            }
            return true
        })
        let toDate
        this.props.downloadnotification.slice().reverse().every( obj => {
            if(data.event_id === obj.event_id){
                toDate = obj.datetime
                return false
            }
            return true
        })
        this.setState({
            recFromDate: fromDate,
            recToDate: toDate
        })
    }

    getLocations = () => {
        let locations = this.props.locationList
        let arr = []
        if (this.state.building && this.state.floor){
            if (locations) {
                for (let i = 0; i < locations.length; i++) {
                    if (locations[i].unit) {
                        arr.push(<option className="dashboard-options" value={locations[i].location_id + ',' + locations[i].unit.id}>
                            {locations[i].room.room_name + ', ' + locations[i].unit.description}
                        </option>)
                    }
                    else {
                        arr.push(<option className="dashboard-options"  value={locations[i].location_id}>{locations[i].room.room_name}</option>)
                    }
                }
            }
        }
        return arr
    }

    handleLocationScan=()=>{
        this.setState({ isLocationScan: true })
             if (notificationScanRef) {
                window.scrollTo(0, notificationScanRef.current.offsetTop) 
            }
    }

    handleError = (err) => {
        console.error(err)
    }

    getMinTime = date => {
        let isToday = moment(date).isSame(moment(), 'day');
        if (isToday) {
            let now = moment(new Date()).toDate();
            return now;
        }
        let diff = moment().diff(moment(date), 'days')
        if (diff>1)
            return moment().endOf('day').toDate()
        return moment().startOf('day').toDate(); 
    }
    
    handleCheckClick = (value) =>{
        this.setState(prevState => ({
            checked: prevState.checked.includes(value)?[...prevState.checked.filter((val) => val !== value)]:[...prevState.checked, value],
        }))
    }

    selectAll = () => {
        this.setState({
        checked: this.state.checked.length < this.props.downloadnotification.length?[...Array(this.props.downloadnotification.length).keys()]:[]})
    }

    render() {
        return (
            <div >
            <div className="manage-page manage-notification-page page-layout" data-tut="reactour__manage">
                <NavBar />
                    <div className={window.innerWidth>900?"dashboard-overview samples-page": "dashboard-overview-100 samples-page"} >
                    <div className="dashboard-content-25" ref={(divElement) => { this.divElement = divElement }}>
                        <Row className="manage-page-header mt-0" form>
                        <Navbar className="navbar-results" light expand="md">
                            <Nav navbar>
                                <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/buildings/addbuildings"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>Manage Locations</span></NavLink>
                                <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/locations"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>View Locations</span></NavLink>
                                <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/notifications/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt=''/>Manage Notifications</span></NavLink>
                            </Nav>
                        </Navbar>
                        </Row>
                        <div data-tut="reactour__apply" className='sample-input-area manage-notification'>
                        <Row form>
                        <Col md={4} xl={2} lg={2}>
                                <Input className={this.state.typeofNotification? this.props.sideBarHover? "sample-input-fields no-display": "sample-input-fields":this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="typeofNotification" id="NotificationType" value={this.state.typeofNotification} onChange={this.handleChange} size="1">
                                    <option value="" default disabled>Notification Type*</option>
                                    <option className="dashboard-options" value="One Time" >One Time</option>
                                    <option className="dashboard-options" value="Recurring" >Recurring</option>
                                </Input>
                            </Col>
                        <Col md={4} xl={4} lg={4}>
                                <Input className={this.state.description ?  this.props.sideBarHover? "sample-input-fields notify-message no-display":"sample-input-fields notify-message":this.props.sideBarHover?"sample-input-fields default-disabled notify-message no-display":"sample-input-fields default-disabled notify-message"} autoComplete="off"  type="text" name="description" id="message" size="50" value={this.state.description} onChange={this.handleChange} placeholder="Message*"/>
                         </Col>
                                    {this.state.typeofNotification === "Recurring" ?
                                        <Col md={4} xl={2} lg={2}>
                                            <DatePicker
                                                className={this.state.datetime ? "sample-input-fields form-control" : "sample-input-fields default-disabled form-control"}
                                                onChange={this.onChange}
                                                selected={this.state.datetime}
                                                placeholderText={this.state.typeofNotification && this.state.typeofNotification !== "Recurring" ? "Date Time*" : "From*"}
                                                excludeOut
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                timeIntervals={15}
                                                timeCaption="time"
                                                dateFormat="MMMM d, yyyy HH:mm"
                                                dateFormatCalendar=" "
                                                minTime={this.state.minTime}
                                                minDate={new Date()}
                                                maxTime={moment().endOf('day').toDate()}
                                                popperModifiers={{
                                                    preventOverflow: {
                                                      enabled: true,
                                                    },
                                                  }}
                                                  popperProps={{
                                                    positionFixed: true
                                                  }}
                                            />
                                            <FontAwesomeIcon className='time-icon' icon={faCalendar} size="lg" />
                                            <FontAwesomeIcon className='time-icon clock-icon clock-icon' icon={faClock} size="lg" />
                                        </Col>
                                        : null
                                    }
                                    {this.state.typeofNotification === "Recurring" ?
                                    <Col md={4} xl={2} lg={2}>
                                    <DatePicker
                                        className={this.state.toDate? "sample-input-fields form-control":"sample-input-fields default-disabled form-control"}
                                        selected={this.state.toDate?moment(this.state.toDate).set({hours:moment(this.state.datetime).hour(), minutes:moment(this.state.datetime).minutes()})._d:this.state.toDate}
                                        onChange={this.onChangeToDate}
                                        filterDate={(date) => {
                                            return moment().subtract(1, 'days') <= date;
                                        }}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        disabled={this.state.typeofNotification!== "Recurring"}
                                        dateFormat="MMMM d, yyyy HH:mm"
                                        dateFormatCalendar=" "
                                        placeholderText="To Date & Time"
                                        popperModifiers={{
                                            preventOverflow: {
                                              enabled: true,
                                            },
                                          }}
                                          popperProps={{
                                            positionFixed: true
                                          }}
                                    />
                                    <FontAwesomeIcon className='time-icon' icon={faCalendar} size="lg"/>
                                    <FontAwesomeIcon className='time-icon clock-icon' icon={faClock} size="lg" />
                                </Col>
                                :null
                                    }
                                    {this.state.typeofNotification === "Recurring" ?
                                    <Col md={4} xl={2} lg={2}>
                                    <MultiSelect
                                        options={[
                                            {value: 0, label: 'Sunday'},
                                            {value: 1, label: 'Monday'},
                                            {value: 2, label: 'Tuesday'},
                                            {value: 3, label: 'Wednesday'},
                                            {value: 4, label: 'Thursday'},
                                            {value: 5, label: 'Friday'},
                                            {value: 6, label: 'Saturday'}
                                        ]}
                                        className="sample-input-fields form-control"
                                        selected={this.state.selected}
                                        onSelectedChanged={selected => this.setState({selected})}
                                        disabled={this.state.typeofNotification !== "Recurring"}
                                        overrideStrings={{
                                            selectSomeItems: "Days*",
                                            allItemsAreSelected: 'All Days are Selected',
                                            selectAll: "Select All",
                                            search: "Search"
                                        }}
                                        id="DayFilter"
                                    />
                                    </Col>:
                                    null
                                    }
                                    {this.state.typeofNotification === "One Time" ?
                                        <Col md={4} xl={2} lg={2}>
                                            <DatePicker
                                                className={this.state.datetime ? "sample-input-fields form-control" : "sample-input-fields default-disabled form-control"}
                                                onChange={this.onChange}
                                                selected={this.state.datetime}
                                                placeholderText={this.state.typeofNotification && this.state.typeofNotification !== "Recurring" ? "Date Time*" : "From*"}
                                                excludeOut
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                timeIntervals={15}
                                                timeCaption="time"
                                                dateFormat="MMMM d, yyyy HH:mm"
                                                dateFormatCalendar=" "
                                                minTime={this.state.minTime}
                                                minDate={new Date()}
                                                maxTime={(moment().endOf('day').toDate())}
                                                popperModifiers={{
                                                    preventOverflow: {
                                                      enabled: true,
                                                    },
                                                  }}
                                                  popperProps={{
                                                    positionFixed: true
                                                  }}
                                            />
                                            <FontAwesomeIcon className='time-icon' icon={faCalendar} size="lg" />
                                            <FontAwesomeIcon className='time-icon clock-icon' icon={faClock} size="lg" />
                                        </Col>:
                                        null
                                    }
                                    <Col md={4} lg={2} xl={2}>
                                        <Input className={this.state.building ? this.props.sideBarHover? "sample-input-fields no-display":"sample-input-fields" :this.props.sideBarHover?"sample-input-fields default-disabled no-display": "sample-input-fields default-disabled"} type="select" name="building" id="Building" value={this.state.building} onChange={this.onSelectBuilding} size="1">
                                            <option value="" default disabled>Building</option>
                                            {this.props.buildingList.map((building, key) => {
                                                return <option className="dashboard-options" id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                            })}
                                        </Input>
                                    </Col>
                                    <Col md={4} lg={2} xl={2}>
                                        <Input className={this.state.floor ? this.props.sideBarHover? "sample-input-fields no-display":"sample-input-fields" : this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="floor" id="Floor" value={this.state.floor} onChange={this.onSelectFloor} size="1">
                                            <option value="" default disabled>Floor</option>
                                            {this.props.floorsList.map((floor, key) => {
                                                return <option className="dashboard-options" id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                            })}
                                        </Input>
                                    </Col>
                                    <Col md={4} lg={2} xl={2}>
                                        <Input className={this.state.location ? this.props.sideBarHover? "sample-input-fields no-display":"sample-input-fields" : this.props.sideBarHover?"sample-input-fields default-disabled no-display": "sample-input-fields default-disabled"} type="select" name="location" id="Location" value={this.state.location} onChange={this.handleChange} size="1">
                                            <option className="dashboard-options" value="" default disabled>Location</option>
                                            {this.getLocations()}
                                        </Input>
                                    </Col>
                                    <Col md={4} lg={2} xl={2}>
                                    <Input className={this.state.location? this.props.sideBarHover? "sample-input-fields no-display" : "sample-input-fields" : this.props.sideBarHover?"sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="text" name="location" id="Location" size="10" value={this.state.location} onChange={this.handleChange} placeholder="LocationId" />
                                </Col>
                                <Col md={4} lg={2} xl={2}>
                                    <Input className={this.state.typeofSamples? this.props.sideBarHover? "sample-input-fields no-display":"sample-input-fields" : this.props.sideBarHover? "sample-input-fields default-disabled no-display": "sample-input-fields default-disabled"}  type="text" name="typeofSamples" id="SampleType" size="10" value={this.state.typeofSamples} onChange={this.handleChange} placeholder="Type of Sample"/>
                                </Col>
                                <Col>
                                <div className = "manage-buttons d-flex justify-content-end">
                                <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                <Button id="applyFloorButton" type="submit" onClick={this.saveData}>Add</Button>
                                </div>
                                </Col>         
                        </Row>
                        </div>
                    </div>
                    <div className="grid-data" >
                    <Row form className=" sample-list-header ml-0" >
                        <Col className="building-heading">Notifications</Col>
                        <Col className="location-header">

                        <div className={this.state.checked.length===1 ? 'dropdown-filter':"dropdown-filter disable-delete"} data-tut="reactour__tableEdit" >
                        <Button 
                            className="export-data-button snooze-button" 
                            id={"snooze" }
                            outline color="secondary" 
                            onClick={ this.state.checked.length===1 ? () => {
                                let data = this.props.downloadnotification;
                                this.toggleEditModal(data[this.state.checked[0]])
                            }:undefined} data-tut="reactour__edit">
                                Snooze
                       </Button>
                            </div>
                            
                        <div className={this.state.checked.length>0? 'dropdown-filter': "dropdown-filter disable-delete"} data-tut="reactour__tableDelete" >
                        <Button
                            className="export-data-button"
                            id={"deleteButton" } 
                            labelColor="#000"
                            backgroundColor="#FFF"
                            fullWidth={true}
                            onClick={this.state.checked.length>0?this.toggleMultiDeleteModal:undefined}
                            data-tut="reactour__delete">
                                Mark as done
                    </Button>
                            </div>
                            </Col>
                    </Row>
                        {this.state.loaderNotification? 
                            <>
                                <div className="loader-notification-oval"><Oval color="#243682" height={60} width={60} /></div>
                                <div className="no-data-msg"> Please wait while we check for notifications...</div>
                            </>
                            : 
                            <>
                                {this.props.downloadnotification.length > 0 ?
                                    <div className='sample-table-height'>
                                        <ReactTable className="Data-Table tables-height"
                                            data={this.props.downloadnotification}
                                            PaginationComponent={Pagination}
                                            defaultPageSize={10}
                                            columns={this.columns}
                                            showPagination={true}
                                            minRows={0}
                                            sortable={false}
                                            data-tut="reactour__table"
                                            getTrProps={(state, rowInfo) => {
                                                if (rowInfo && rowInfo.row) {
                                                return {
                                                    onClick: () => { this.handleCheckClick(rowInfo.index) },
                                                    className: this.state.checked.includes(rowInfo.index) ? "table-selected-row" : "",
                                                }
                                                }else{
                                                return {}
                                                }
                                            }
                                            }
                                        />
                                    </div>
                                    : 
                                    <>
                                    {this.props.downloadnotification.length === 0?
                                        <div className="no-data-msg"> No Notifications Available</div>
                                        : null    
                                    }
                                    </>            
                                }
                            </>
                        } 
                    </div>
                </div>

                <Modal isOpen={this.state.isDeleteModalOpen} toggle={this.toggleDeleteModal}>
                    <ModalHeader toggle={this.toggleDeleteModal} className="edit-popup">Marking as Done</ModalHeader>
                    <ModalBody>
                        Are you sure you want to Mark the Notifications on <i>{this.state.deleteDate}</i> as done?
                    <div className="float-sm-right mt-3">
                            <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary" onClick={this.toggleDeleteModal}>Cancel</Button>
                            <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteNotification}>Delete</Button>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isEditModalOpen} toggle={this.toggleEditModal}>
                    <ModalHeader toggle={this.toggleEditModal} className="edit-popup">Update the Notification
                    </ModalHeader>
                    <ModalBody className = "sample-edit-body">
                        <Form>
                            <FormGroup className="mb-0">
                                <div>
                                    <Row form>
                                        <Col md={0.5}>
                                            <Label className="edit-label-names">Date & Time <span className="required-icon">*</span></Label>
                                            <div>
                                                <DatePicker
                                                    id="edit-date-time"
                                                    className="form-control edit-input-values edit-date-time"
                                                    onChange={this.onChangeDate} selected={this.state.editdate_time}
                                                    excludeOut
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    showTimeSelect
                                                    timeFormat="HH:mm"
                                                    timeIntervals={15}
                                                    timeCaption="time"
                                                    dateFormat="MMMM d, yyyy HH:mm"
                                                    dateFormatCalendar=" "
                                                    minTime={this.state.editMinTime} 
                                                    minDate={new Date()}
                                                    maxTime={moment().endOf('day').toDate()}
                                                    popperModifiers={{
                                                        preventOverflow: {
                                                          enabled: true,
                                                        },
                                                      }}
                                                      popperProps={{
                                                        positionFixed: true
                                                      }}
                                                    />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div>
                                    <Label className="edit-label-names">Message<span className="required-icon">*</span></Label>
                                    <Input type="textarea" id="editComments" name="editMessage" className="edit-input-values" size="10" value={this.state.editMessage} onChange={this.handleChange} placeholder="Enter Message" />
                                </div>
                                <div>
                                    <Row form>
                                        <Col>
                                            <Label className="edit-label-names">Building <span className="required-icon">*</span></Label>
                                            <Input className="edit-input-values" type="select" name="building" value={this.state.building} onChange={this.onSelectBuilding} size="1">
                                                <option value="" default disabled>Building</option>
                                                {this.props.buildingList.map((building, key) => {
                                                    return <option id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                                })}
                                            </Input>
                                        </Col>
                                        <Col>
                                            <Label className="edit-label-names">Floor</Label>
                                            <Input className="edit-input-values" type="select" name="floor" value={this.state.floor} onChange={this.onSelectFloor} size="1">
                                                <option value="" default disabled>Floor</option>
                                                {this.props.floorsList.map((floor, key) => {
                                                    return <option id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                                })}
                                            </Input>
                                        </Col>
                                    </Row>
                                </div>
                                <div>
                                    <Label className="edit-label-names" id="edit-location-label">Location</Label>
                                    <Input className="edit-input-values" id="Location" type="select" name="location" value={this.state.location} onChange={this.handleChange} size="1">
                                        <option value="" default disabled>Location</option>
                                        {this.getLocations()}
                                    </Input>
                                </div>
                                <div>
                                    <Label className="edit-label-names">Type of Sample</Label>
                                    <Input className="edit-input-values" type="text" name="edittypeofSamples" id="type-of-sample" size="10" value={this.state.edittypeofSamples} onChange={this.handleChange} placeholder="Enter Sample Type" />
                                </div>
                            </FormGroup>
                        </Form>

                        <div className="justify-content-between">
                            <div className="float-right ml-auto">
                                <Button className="button-cancel mr-2" outline color="secondary" type="reset" onClick={this.cancelData}>Cancel</Button>
                                <Button className="button-size save-upload-delete-button" id="saveBtn" type="submit" onClick={this.saveData}>SAVE</Button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isRecurrentModalOpen} toggle={this.toggleRecurrentModal}>
                    <ModalHeader toggle={this.toggleRecurrentModal} className="edit-popup">Update All events of this Notification</ModalHeader>
                    <ModalBody className = "sample-edit-body">
                        <Form>
                            <FormGroup className="mb-0">
                                <Row form>
                                    <Col>
                                        <Label className="edit-label-names">From <span className="required-icon">*</span></Label>
                                        <Input
                                            className="edit-input-values"
                                            type="text"
                                            value={moment(this.state.recFromDate).format('MMMM D, YYYY')}
                                            disabled={true}/>
                                    </Col>
                                    <Col>
                                        <Label className="edit-label-names">To <span className="required-icon">*</span></Label> 
                                        <Input
                                            className="edit-input-values"
                                            type="text"
                                            value={moment(this.state.recToDate).format('MMMM D, YYYY')}
                                            disabled={true}/>
                                    </Col>
                                </Row>
                                <div>
                                    <Row form>
                                        <Col md={0.5}>
                                            <Label className="edit-label-names">Time <span className="required-icon">*</span></Label>
                                            <div>
                                                <DatePicker
                                                    id="edit-date-time"
                                                    className="form-control edit-input-values edit-date-time"
                                                    onChange={this.onChangeDate} selected={this.state.editdate_time}
                                                    showTimeSelect={true}
                                                    showTimeSelectOnly
                                                    timeFormat="HH:mm"
                                                    timeIntervals={15}
                                                    timeCaption="time"
                                                    dateFormat="HH:mm"
                                                    dateFormatCalendar=" "
                                                    popperModifiers={{
                                                        preventOverflow: {
                                                          enabled: true,
                                                        },
                                                      }}
                                                      popperProps={{
                                                        positionFixed: true
                                                      }}
                                                    />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div>
                                    <Label className="edit-label-names">Message<span className="required-icon">*</span></Label>
                                    <Input type="textarea" id="editComments" name="editMessage" className="edit-input-values" size="10" value={this.state.editMessage} onChange={this.handleChange} placeholder="Enter Message" />
                                </div>
                                <div>
                                    <Row form>
                                        <Col>
                                            <Label className="edit-label-names">Building <span className="required-icon">*</span></Label>
                                            <Input className="edit-input-values" type="select" name="building" value={this.state.building} onChange={this.onSelectBuilding} size="1">
                                                <option value="" default disabled>Building</option>
                                                {this.props.buildingList.map((building, key) => {
                                                    return <option id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                                })}
                                            </Input>
                                        </Col>
                                        <Col>
                                            <Label className="edit-label-names">Floor</Label>
                                            <Input className="edit-input-values" type="select" name="floor" value={this.state.floor} onChange={this.onSelectFloor} size="1">
                                                <option value="" default disabled>Floor</option>
                                                {this.props.floorsList.map((floor, key) => {
                                                    return <option id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                                })}
                                            </Input>
                                        </Col>
                                    </Row>
                                </div>
                                <div>
                                    <Label className="edit-label-names" id="edit-location-label">Location</Label>
                                    <Input className="edit-input-values" id="Location" type="select" name="location" value={this.state.location} onChange={this.handleChange} size="1">
                                        <option value="" default disabled>Location</option>
                                        {this.getLocations()}
                                    </Input>
                                </div>
                                <div>
                                    <Label className="edit-label-names">Type of Sample</Label>
                                    <Input className="edit-input-values" type="text" name="edittypeofSamples" id="type-of-sample" size="10" value={this.state.edittypeofSamples} onChange={this.handleChange} placeholder="Enter Sample Type" />
                                </div>
                            </FormGroup>
                        </Form>
                        <div className="float-sm-left mt-3">
                            <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.toggleDeleteAllModel}>Delete All</Button>
                        </div>
                        <div className="float-sm-right mt-3">
                            <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary"  onClick={this.cancelData}>Cancel</Button>
                            <Button className="custom-button save-upload-delete-button mr-2" id="saveBtn" type="submit" onClick={this.updateRecurrentData}>SAVE</Button>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isMultiDeleteModalOpen} toggle={this.toggleMultiDeleteModal}>
                    <ModalHeader toggle={this.toggleMultiDeleteModal} className="edit-popup delete-title">
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle}/>
                        Delete Notifications
                    </ModalHeader>
                    <ModalBody className="delete-popup-body delete-popup-body-align">
                        Are you sure you want to delete the notifications selected ?
                    </ModalBody>
                    <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                        <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary" onClick={this.toggleMultiDeleteModal}>No</Button>
                        <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteSelectedNotifications}>Yes</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.isDeleteAllModalOpen} toggle={this.toggleDeleteAllModel}>
                    <ModalHeader toggle={this.toggleDeleteAllModel} className="edit-popup">Delete all notifications</ModalHeader>
                    <ModalBody>
                        Are you sure you want to delete all these recurring notifications ?
                    <div className="float-sm-right mt-3">
                            <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary"  onClick={this.toggleDeleteAllModel}>Cancel</Button>
                            <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteMultipleNotifications}>Delete</Button>
                        </div>
                    </ModalBody>
                </Modal>
                <ToastContainer autoClose={3000} />
                {this.props.isTourOpen?<Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} />:null}
            </div>

        </div>
        )
    }
}

const mapStateToProps = state => {

    return {
        downloadnotification: state.notification_data.downloadnotificationData,
        locationList: state.sample_data.locationList,
        notificationPagination: state.notification_data.allPagination,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
        roomsList: state.floor_data.roomsList,
        notificationParams: state.notification_data.notificationParams
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        saveNotification,
        updateNotification,
        updateRecurrentNotifications,
        deleteNotification,
        deleteMultipleNotifications,
        downloadnotificationData,
        fetchLocationList,
        fetchBuilding,
        fetchFloors,
        updateLocationStateFilters
    }
)(Notification), 'Manage Notifications', 'Notification');